function assertFunction(value, methodName, label) {
  if (typeof value !== 'function') {
    throw new Error(`[live/ports] ${label} is missing required method: ${methodName}`)
  }
}

export const PRESENCE_EVENT_TYPES = Object.freeze({
  participantMetadataChanged: 'participant-metadata-changed',
  participantJoined: 'participant-joined',
  participantLeft: 'participant-left',
  error: 'error',
})

/**
 * Provider-neutral presence / metadata contract.
 *
 * @typedef {object} PresencePort
 * @property {(config: object) => Promise<unknown>} connect
 * @property {() => Promise<unknown>} disconnect
 * @property {(metadata: object) => Promise<unknown>} publishLocalParticipantMetadata
 * @property {(listener: (event: object) => void) => () => void} subscribe
 */

/**
 * @param {unknown} value
 * @param {string} [label='PresencePort']
 * @returns {PresencePort}
 */
export function assertPresencePort(value, label = 'PresencePort') {
  assertFunction(value?.connect, 'connect', label)
  assertFunction(value?.disconnect, 'disconnect', label)
  assertFunction(
    value?.publishLocalParticipantMetadata,
    'publishLocalParticipantMetadata',
    label,
  )
  assertFunction(value?.subscribe, 'subscribe', label)

  return value
}
